import { Component, Input } from '@angular/core';

@Component({
  selector: 'client-data-request-sent',
  templateUrl: './client-request-sent.component.html',
  styleUrls: ['./client-request-sent.component.scss'],
  standalone: false,
})
export class ClientRequestSentComponent {
  @Input() public navigateToListHandler: any;
}
